import React from 'react';
import ResultCard from './ResultCard';
import { ArcherContext } from '../../context/ArcherContext';

const Result = (props) => {

    const { resultLookupTableIndex, renewableElectricity } = React.useContext(ArcherContext);

    const [count, setCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [resultDisabled, setResultDisabled] = React.useState(true);

    const [co2PercentageSaved, setCo2PercentageSaved] = React.useState(0);
    const [costComparisonPercentage, setCostComparisonPercentage] = React.useState(0);
    const [kilowattPercentageSaved, setKilowattPercentageSaved] = React.useState(0);
    const [kilowattHoursSaved, setKilowattHoursSaved] = React.useState(0);
    const [co2EquivalentSaved, setCo2EquivalentSaved] = React.useState(0);
    const [treeEquivalentSaved, setTreeEquivalentSaved] = React.useState(0);
    const [costComparison, setCostComparison] = React.useState(0);

    React.useEffect(() => {

        if (resultLookupTableIndex > -1) {
            setCo2PercentageSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].co2PercentageSavedGreen : props.resultLookupTable[resultLookupTableIndex].co2PercentageSavedStandard);

            setKilowattHoursSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].kilowattHoursSavedGreen : props.resultLookupTable[resultLookupTableIndex].kilowattHoursSavedStandard);

            setKilowattPercentageSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].kilowattPercentageSavedGreen : props.resultLookupTable[resultLookupTableIndex].kilowattPercentageSavedStandard);

            setCo2PercentageSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].co2PercentageSavedGreen : props.resultLookupTable[resultLookupTableIndex].co2PercentageSavedStandard);

            setCo2EquivalentSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].co2EquivalentSavedGreen : props.resultLookupTable[resultLookupTableIndex].co2EquivalentSavedStandard);

            setTreeEquivalentSaved(renewableElectricity ? props.resultLookupTable[resultLookupTableIndex].treeEquivalentSavedGreen : props.resultLookupTable[resultLookupTableIndex].treeEquivalentSavedStandard);

            setCostComparison(props.resultLookupTable[resultLookupTableIndex].costComparison);
            setCostComparisonPercentage(props.resultLookupTable[resultLookupTableIndex].costComparisonPercentage);
        }
    }, [resultLookupTableIndex, renewableElectricity]);

    // Loader
    React.useEffect(() => {
        const duration = 1500; // 1.5 seconds
        const increment = 100; // counting from 0 to 100
        const intervalTime = duration / increment; // time per increment
        if (props.startCount) {
            setCount(0);
            setLoading(true);
            setResultDisabled(true);

            const interval = setInterval(() => {
                setCount((prevCount) => {
                    if (prevCount < 100) {
                        return prevCount + 1;
                    } else {
                        props.handleDialogPopup('result');
                        setLoading(false);
                        setResultDisabled(false);
                        clearInterval(interval);
                        return prevCount;
                    }
                });
            }, intervalTime);

            return () => clearInterval(interval); // Cleanup interval on unmount
        }
    }, [props.startCount]);

    return (
        <>
            {/* Result popup */}
            <dialog className="calculator__result-dialog">
                <div>
                    <h2>{count}%</h2>
                    <div className="calculator__result-dialog--label" >
                        <p>{props.translations.loaderDisclaimer}</p>
                    </div>
                </div>
            </dialog>

            {/* Result */}
            <div className={`calculator-result ${resultDisabled ? 'disabled' : ''}`} >

                <div id="calculator-results" className='calculator-result__card-wrapper'>
                    <ResultCard percentValue={loading ? 0 : kilowattPercentageSaved}
                        preamble={props.translations.energySavingsPreamble}
                        energySavings={props.translations.energySavingsLabel}
                        disabled={resultDisabled}
                    >
                        <div className="calculator-result__money-savings calculator-result__electric-energy">{props.translations.electricalSavingsLabel} {loading ? 0 : kilowattHoursSaved} hours</div>

                    </ResultCard>
                    <ResultCard percentValue={loading ? 0 : co2PercentageSaved}
                        preamble={props.translations.reducedCo2EmissionsPreamble}
                        energySavings={props.translations.reducedCo2EmissionsLabel}
                        disabled={resultDisabled}
                    >
                        <div className="calculator-result__money-savings">{loading ? 0 : co2EquivalentSaved} {props.translations.kCo2eLabel}/{props.translations.yearLabel}</div>
                    </ResultCard>
                    <ResultCard percentValue={loading ? 0 : costComparisonPercentage}
                        preamble={props.translations.financialSavingsPreamble}
                        energySavings={props.translations.financialSavingsLabel}
                        disabled={resultDisabled}
                    >
                        <div className="calculator-result__money-savings">{loading ? 0 : costComparison} {'kr'}/{props.translations.yearLabel}</div>
                    </ResultCard>

                </div>

                <div className='calculator-result__additional-info'>
                    <div className='calculator-result__additional-info_heading'>{props.translations.estimatedEnergyUsage}</div>
                    <div className='calculator-result__additional-info_result'><span className='calculator-result__additional-info_value'>{loading ? 0 : treeEquivalentSaved}</span> <span className='archer-result__additional-info_label'>
                        {props.translations.trees}
                    </span>
                    </div>

                </div>
                {props.findOutMoreLink.href &&
                    <div className='calculator-result__additional-info--button-wrapper'>
                        <div className='calculator-result__additional-settings'>
                            {resultDisabled
                                ? <button className="button button--rounded" disabled>{props.findOutMoreLink.text}
                                </button>
                                : <a href={props.findOutMoreLink.href} target={props.findOutMoreLink.target} className="button button--rounded" disabled={resultDisabled}>{props.findOutMoreLink.text}
                                </a>
                            }
                        </div>
                    </div>
                }

            </div >
        </>
    );
};

export default Result;
